
import Vue from 'vue'

type NameToListener = { [key: string]: (event: Event) => void }

export default Vue.extend({
  props: [
    'appendIcon',
    'autofocus',
    'disabled',
    'dirty',
    'height',
    'hideDetails',
    'invalid',
    'errors',
    'label',
    'prependIcon',
    'solo',
    'type',
    'value'
  ],
  data () {
    return {
      dirtyInternal: this.dirty,
      ignoreEvents: !this.dirty
    }
  },
  methods: {
    touch () {
      if (!this.ignoreEvents) {
        this.dirtyInternal = true
        this.$emit('touch')
      }
    },
    reset () {
      if (!this.ignoreEvents) {
        this.dirtyInternal = false
        this.$emit('reset')
      }
    },
    input (event: string) {
      this.reset()
      this.$emit('input', event)
    },
    focus () {
      ;(this.$refs.input as HTMLInputElement).focus()
    }
  },
  computed: {
    errorMessages (): string[] {
      if (this.dirty) {
        return Object.entries(this.errors || {})
          .filter(([, value]) => value)
          .map(([key]) => key)
      } else {
        return []
      }
    },
    error (): boolean {
      return this.dirtyInternal && (
        this.invalid || this.errorMessages.length > 0)
    },
    extraListeners (): NameToListener {
      const nameToListener: NameToListener = {}
      if (this.$listeners['append-click']) {
        nameToListener['click:append'] = (event) => { this.$emit('append-click', event) }
      }
      if (this.$listeners['prepend-click']) {
        nameToListener['click:prepend'] = (event) => { this.$emit('prepend-click', event) }
      }
      return nameToListener
    }
  },
  watch: {
    dirty (value: boolean) {
      if (value !== this.dirtyInternal) {
        this.dirtyInternal = value
        this.ignoreEvents = !value
      }
    }
  }
})
